module.exports = __webpack_public_path__ + "static/media/ecommerce-shop-min.25bce570.png";